import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '@cpd-app/shared-module/shared.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ChatViaComponent } from './containers/chat-via/chat-via.component';
import { ChatHeaderComponent } from './components/chat-header/chat-header.component';
import { ChatSidebarComponent } from './components/chat-sidebar/chat-sidebar.component';
import { ConversationComponent } from './components/conversation/conversation.component';
import { ConversationCardComponent } from './components/conversation-card/conversation-card.component';
import { ConversationSkeletonComponent } from './components/conversation-skeleton/conversation-skeleton.component';
import { ConversationsComponent } from './components/conversations/conversations.component';

@NgModule({
  declarations: [
    ChatViaComponent,
    ChatSidebarComponent,
    ConversationComponent,
    ConversationCardComponent,
    ConversationSkeletonComponent,
    ConversationsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    FontAwesomeModule,
    // S.6. Standalone so the counselor Via sidebar on a shared report can use
    // the same header without pulling in this module and its facades.
    ChatHeaderComponent
  ],
  exports: [ChatViaComponent]
})
export class ChatViaModule {}
